import React, { useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';
import Select from "react-select";
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Table } from "antd";
import { useFormik } from 'formik';
import { BeatLoader } from 'react-spinners';
// import Pagination from '../../Pagination';
import Skeleton from 'react-loading-skeleton'
import { Tooltip } from 'antd';
// import { adminMainUrl } from '../../../../../../../Config';
// import { DesignationApi } from '../../../../../../../Redux/action/MasterAction';
import { adminMainUrl } from '../../../../../../../../Config';
import { DesignationApi } from '../../../../../../../../Redux/action/MasterAction';

const ContainerDOSea = ({ accessedModules, accessedPermission }) => {
    const [currentData, setCurrentData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [dataOffset, setDataOffset] = useState(0);
    const dataPerPage = 10;
    const [reload, setReload] = useState(false);
    const [spinnerLoader, setSpinnerLoader] = useState(false)
    const [DesignationName, setDesignationName] = useState(null)
    const [DesignationId, setDesignationId] = useState(null)
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // Number of items per page
    // const { name } = useParams();
    const dispatch = useDispatch();
    const {
        loadingDesignationTypeApi,
        findDesignationTypeData,
        findDesignationTypeDataError,

    } = useSelector(state => state?.MasterReducer);
    useEffect(() => {
        dispatch(DesignationApi(adminMainUrl));
    }, [adminMainUrl, reload]);
    const handleSuccess = () => {
        // Toggle reload to trigger useEffect
        setReload(prev => !prev);
    };

    // Initialize Formik
    const statusChange = async (id) => {
        setSpinnerLoader(true)
        try {
            const response = await fetch(`${adminMainUrl}/api/designation/status-change`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': Cookies.get('token'), // Assuming token is stored in cookies
                },
                body: JSON.stringify({ id: id.toString() }),
            });

            const data = await response.json();

            if (response.ok) {
                setSpinnerLoader(false)
                handleSuccess(); // Call the success handler
                toast.success(data?.msg);
            } else {
                setSpinnerLoader(false)
                toast.error(data?.msg);
            }
        } catch (error) {
            setSpinnerLoader(false)
            console.error('Network error:', error);
        }
    };

    const handleChange = (id) => {
        // if (accessedPermission.includes("state_change_master_data")) {
        statusChange(id);
        // }
    };
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = findDesignationTypeData?.data

    const totalPages = Math.ceil(findDesignationTypeData?.data?.length / itemsPerPage);

    // Function to change page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Function for "Next" and "Previous" buttons
    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };
    const arr = new Array(5).fill(null);
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const onSelectChange = newSelectedRowKeys => {
        setSelectedRowKeys(newSelectedRowKeys)
    }
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange
    }
    const [editshow, setEditShow] = useState(false);
    const handleEditClose = () => setEditShow(false);
    const handleEditShow = () => setEditShow(true);
    let formik = useFormik({

        onSubmit: (values) => {
            console.log(values)
        },
    });
    const columns = [
        { title: "Container Type", dataIndex: "SNo", key: "SNo" },
        { title: "Place Of Delivery", dataIndex: "Alias", key: "Alias" },
    ];

    const dataSource = [
        {
            key: "", // Add a unique key for each row
            SNo: "", // Changed to camelCase
           
        },
    ]
    const [addShow, setAddShow] = useState(false);
    const handleAddClose = () => setAddShow(false);
    const handleAddShow = () => setAddShow(true);

    return (
        <>
            <div className="page-wrapper">
                <div className="content">
                    <div className="row">
                        <div className="col-md-12">
                            {/* Page Header */}
                            <div className="page-header">
                                <div className="row align-items-center">
                                    <div className="col-8">
                                        <h4 className="page-title">
                                        Container DO Sea Export<span className="count-title">23</span>
                                        </h4>
                                    </div>
                                    <div className="col-4 text-end">
                                        <div className="head-icons">
                                            <a
                                                href="javascript:void(0);"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                data-bs-original-title="Collapse"
                                                id="collapse-header"
                                            >
                                                <i className="ti ti-chevrons-up" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* /Page Header */}
                        </div>
                    </div>
                    <div className="row border-bottom-2 card m-1">
                <div className="col-md-12 card-body">
                
                <div className="row mt-2">
                <div className="col-md-6">
                                                <div className=' '>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                       Shipping Line / Agent	
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                    <Select
                                                            className='custom-selector '
                                                            name="role_id"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                
                                <div className="col-md-6">
                                                <div className=' '>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                    DO No
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                    <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name='search_by'
                                                            />
                                                    </div>
                                                </div>
                                            </div>
                                <div className="col-md-6">
                                                <div className=' '>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                    Date
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                    <input
                                                                type="date"
                                                                className="form-control form-control-sm"
                                                                name='search_by'
                                                            />
                                                    </div>
                                                </div>
                                            </div>
                                <div className="col-md-6">
                                                <div className=' '>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                    Booking No
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                    <Select
                                                            className='custom-selector '
                                                            name="role_id"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                <div className="col-md-6">
                                                <div className=' '>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                    Carrier Booking No
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                    <Select
                                                            className='custom-selector '
                                                            name="role_id"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                <div className="col-md-6">
                                                <div className=' '>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                    From port
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                    <Select
                                                            className='custom-selector '
                                                            name="role_id"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                <div className="col-md-6">
                                                <div className=' '>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                    To port
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                    <Select
                                                            className='custom-selector '
                                                            name="role_id"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                <div className="col-md-6">
                                                <div className=' '>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                    Vessel/Voyage
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                    <Select
                                                            className='custom-selector '
                                                            name="role_id"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                <div className="col-md-6">
                                                <div className=' '>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                    Yard
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                    <Select
                                                            className='custom-selector '
                                                            name="role_id"
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-12 mt-4">
                                                <h6>Container Details</h6>
                                            </div>
                                </div>
                            <div className="table-responsive custom-table mt-3">
                                <Table className="table datanew dataTable no-footer" pagination={false}
                                    dataSource={dataSource} columns={columns} />
                            </div>
                    
                <div className="d-flex flex-wrap gap-2 mt-2 pb-2" style={{ borderBottom: '1px solid #d4d4d4' }}>
                    <button className="btn btn-primary text-xs" type="button">
                        New
                    </button>
                    <button className="btn btn-primary text-xs" type="button">
                        Edit
                    </button>
                    <button className="btn btn-primary text-xs" type="button">
                        Update
                    </button>
                    <button className="btn btn-primary text-xs" type="button">
                        Delete
                    </button>
                </div>
                </div>
                <div className="d-flex justify-content-end gap-2 mt-2 mb-3">
                        {/* <button className="btn btn-primary text-xs" type="submit" disabled={isSubmitting}>
                            {isSubmitting ? <i className="fa fa-spinner fa-spin" /> : "Submit"}
                        </button> */}
                        <button className="btn btn-primary text-xs" type="submit">
                            Submit
                        </button>
                        <button className="btn btn-primary text-xs" type="submit">
                            Save & Close
                        </button>
                        <button className="btn btn-primary text-xs" type="submit">
                            Save & New
                        </button>
                        <button className="btn btn-light text-xs" type="submit">
                            Close
                        </button>
                    </div>
            </div>
                </div>
            </div>
        </>

    )
}

export default ContainerDOSea